import api from './api';

export const authService = {
  register: async (userData) => {
    const response = await api.post('/auth/register', userData);
    if (response.data.access_token) {
      localStorage.setItem('token', response.data.access_token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  login: async (credentials) => {
    const response = await api.post('/auth/login', credentials);
    if (response.data.access_token) {
      localStorage.setItem('token', response.data.access_token);
      localStorage.setItem('user', JSON.stringify(response.data.user));
    }
    return response.data;
  },

  logout: async () => {
    await api.post('/auth/logout');
    localStorage.removeItem('token');
    localStorage.removeItem('user');
  },

  getCurrentUser: () => {
    const userStr = localStorage.getItem('user');
    return userStr ? JSON.parse(userStr) : null;
  },

  isAuthenticated: () => {
    return !!localStorage.getItem('token');
  },
};

export const exerciseService = {
  getAll: () => api.get('/exercises'),
  get: (id) => api.get(`/exercises/${id}`),
  create: (data) => api.post('/exercises', data),
  update: (id, data) => api.put(`/exercises/${id}`, data),
  delete: (id) => api.delete(`/exercises/${id}`),
  search: (query) => api.get(`/exercises/search?q=${encodeURIComponent(query)}`),
};

export const muscleGroupService = {
  getAll: () => api.get('/musclegroups'),
};

export const routineService = {
  getAll: () => api.get('/routines'),
  get: (id) => api.get(`/routines/${id}`),
  getByDay: (day) => api.get(`/routines/day/${day}`),
  create: (data) => api.post('/routines', data),
  update: (id, data) => api.put(`/routines/${id}`, data),
  delete: (id) => api.delete(`/routines/${id}`),
};

export const workoutService = {
  getAll: () => api.get('/workouts'),
  get: (id) => api.get(`/workouts/${id}`),
  start: (data) => api.post('/workouts/start', data),
  addSeries: (workoutId, data) => api.post(`/workouts/${workoutId}/series`, data),
  finish: (workoutId, data) => api.put(`/workouts/${workoutId}/finish`, data),
  delete: (id) => api.delete(`/workouts/${id}`),
};

export const recordService = {
  getAll: () => api.get('/records'),
  check: (data) => api.post('/records/check', data),
};

export const achievementService = {
  getProgress: () => api.get('/achievements/progress'),
};

export const anthropometricService = {
  getAll: () => api.get('/anthropometric'),
  get: (id) => api.get(`/anthropometric/${id}`),
  create: (data) => api.post('/anthropometric', data),
  update: (id, data) => api.put(`/anthropometric/${id}`, data),
  delete: (id) => api.delete(`/anthropometric/${id}`),
  getLatest: () => api.get('/anthropometric/latest'),
  getEvolution: (metric, limit = 12) => api.get(`/anthropometric/evolution?metric=${metric}&limit=${limit}`),
  getStats: () => api.get('/anthropometric/stats'),
};

export * as socialService from './socialService';
